import { render, staticRenderFns } from "./RestaurantTypes.vue?vue&type=template&id=628add83&scoped=true"
import script from "./RestaurantTypes.vue?vue&type=script&lang=js"
export * from "./RestaurantTypes.vue?vue&type=script&lang=js"
import style0 from "./RestaurantTypes.vue?vue&type=style&index=0&id=628add83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628add83",
  null
  
)

export default component.exports